var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 page_content_area"},[_c('div',{staticClass:"container enterprises_content_area"},[_c('div',{staticClass:"white_block"},[_c('enterprise-intern-form',{on:{"load":_vm.loadFormData,"submit":_vm.submitInternAply}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }